import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../API";
import { RootState } from "../../app/store";
import { CognitoUserGroups } from "./userUtils";
import { QueryStatus } from "../../app/types";

interface UsersSlice {
  currentUser?: User;
  cognitoGroups?: CognitoUserGroups[];
  siblingUsers: User[];
  siblingUsersStatus: QueryStatus;
  siblingUsersError: string | null;
}

const initialState: UsersSlice = {
  currentUser: undefined,
  cognitoGroups: [],
  siblingUsers: [],
  siblingUsersStatus: "idle",
  siblingUsersError: null
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<User | undefined>) => {
      state.currentUser = action.payload;
    },
    setUserCognitoGroups: (
      state,
      action: PayloadAction<CognitoUserGroups[]>
    ) => {
      state.cognitoGroups = action.payload;
    },
    setSiblingUsersStatus: (state, action: PayloadAction<QueryStatus>) => {
      state.siblingUsersStatus = action.payload;
    },
    setSiblingUsers: (state, action: PayloadAction<User[]>) => {
      state.siblingUsers = action.payload;
    },
    setSiblingUsersError: (state, action: PayloadAction<string | null>) => {
      state.siblingUsersError = action.payload;
    }
  }
});

export const {
  setCurrentUser,
  setUserCognitoGroups,
  setSiblingUsers,
  setSiblingUsersStatus,
  setSiblingUsersError
} = usersSlice.actions;

export const selectCurrentUser = (state: RootState) => state.users.currentUser;
export const selectUserCognitoGroups = (state: RootState) =>
  state.users.cognitoGroups;
export const selectSiblingUsers = (state: RootState) =>
  state.users.siblingUsers;
export const selectSiblingUsersStatus = (state: RootState) =>
  state.users.siblingUsersStatus;
export const selectSiblingUsersError = (state: RootState) =>
  state.users.siblingUsersError;

export default usersSlice.reducer;
